import { render } from "./EstateCardSlider.vue?vue&type=template&id=ba6292d2&scoped=true"
import script from "./EstateCardSlider.vue?vue&type=script&lang=js"
export * from "./EstateCardSlider.vue?vue&type=script&lang=js"

import "./EstateCardSlider.vue?vue&type=style&index=0&id=ba6292d2&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba6292d2"]])

export default __exports__